import React, { useEffect, useState } from 'react';
import { getFactures, getPartenaires } from '../services/api';

const Factures: React.FC = () => {
  const [factures, setFactures] = useState<any[]>([]);
  const [partenaires, setPartenaires] = useState<any[]>([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [filters, setFilters] = useState<any>({ annee: new Date().getFullYear().toString() });

  useEffect(() => { getPartenaires().then(r => setPartenaires(r.data)); }, []);

  useEffect(() => {
    const params: Record<string, string> = { page: page.toString(), limit: '30' };
    Object.entries(filters).forEach(([k, v]) => { if (v) params[k] = v as string; });
    getFactures(params).then(r => {
      setFactures(r.data.data);
      setTotal(r.data.total);
      setTotalPages(r.data.totalPages);
    });
  }, [page, filters]);

  const moisNoms = ['', 'Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Jun', 'Jul', 'Aou', 'Sep', 'Oct', 'Nov', 'Dec'];

  return (
    <div>
      <h2 style={{ marginBottom: 20, color: '#333' }}>Factures ({total.toLocaleString()})</h2>

      <div className="filters-bar">
        <select value={filters.partenaire_id || ''} onChange={e => { setFilters({ ...filters, partenaire_id: e.target.value }); setPage(1); }}>
          <option value="">Tous les partenaires</option>
          {partenaires.map(p => <option key={p.id} value={p.id}>{p.libelle}</option>)}
        </select>
        <select value={filters.mois || ''} onChange={e => { setFilters({ ...filters, mois: e.target.value }); setPage(1); }}>
          <option value="">Tous les mois</option>
          {moisNoms.slice(1).map((m, i) => <option key={i + 1} value={i + 1}>{m}</option>)}
        </select>
        <select value={filters.annee || ''} onChange={e => { setFilters({ ...filters, annee: e.target.value }); setPage(1); }}>
          {Array.from({ length: 5 }, (_, i) => new Date().getFullYear() - i).map(y => (
            <option key={y} value={y}>{y}</option>
          ))}
        </select>
        <select value={filters.paye || ''} onChange={e => { setFilters({ ...filters, paye: e.target.value }); setPage(1); }}>
          <option value="">Tous statuts</option>
          <option value="1">Payees</option>
          <option value="0">Impayees</option>
        </select>
      </div>

      <div className="data-table-wrapper">
        <table className="data-table">
          <thead>
            <tr>
              <th>Reference</th>
              <th>Abonne</th>
              <th>Partenaire</th>
              <th>Periode</th>
              <th>Categorie</th>
              <th>Conso</th>
              <th>Montant TTC</th>
              <th>Paye</th>
              <th>Statut</th>
            </tr>
          </thead>
          <tbody>
            {factures.map((f: any) => (
              <tr key={f.id}>
                <td><strong>{f.reference}</strong></td>
                <td>{f.abonne}</td>
                <td>{f.partenaire}</td>
                <td>{moisNoms[f.mois]} {f.annee}</td>
                <td>{f.categorie}</td>
                <td>{f.consommation} m3</td>
                <td>{f.montantttc?.toLocaleString()} FCFA</td>
                <td>{f.totalpaye?.toLocaleString()} FCFA</td>
                <td>
                  <span style={{
                    padding: '3px 10px', borderRadius: 12, fontSize: 12, fontWeight: 600,
                    background: f.paye === 1 ? '#e8f5e9' : '#ffebee',
                    color: f.paye === 1 ? '#2e7d32' : '#c62828'
                  }}>
                    {f.paye === 1 ? 'Payee' : 'Impayee'}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="pagination">
        <button disabled={page <= 1} onClick={() => setPage(page - 1)}>Precedent</button>
        <span style={{ padding: '8px 14px', fontSize: 14 }}>Page {page} / {totalPages}</span>
        <button disabled={page >= totalPages} onClick={() => setPage(page + 1)}>Suivant</button>
      </div>
    </div>
  );
};

export default Factures;
